import { Component, inject } from '@angular/core';
import { MatTabChangeEvent, MatTabsModule } from '@angular/material/tabs';
import { CompaniesComponent } from './companies/companies.component';
import { MatIconModule } from '@angular/material/icon';
import { SitewideComponent } from './sitewide/sitewide.component';
import { SiteUsersChartComponent } from './site-users/site-users.component';
import { MatMenuModule } from '@angular/material/menu';
import { StorageService } from '@static/services/storage.service';
import { KEY_SITEADMIN_CURRENT_TAB } from '@static/storage-keys';

@Component({
  selector: 'app-site-admin',
  imports: [
    CompaniesComponent,
    SitewideComponent,
    SiteUsersChartComponent,
    MatTabsModule,
    MatIconModule,
    MatMenuModule,
  ],
  templateUrl: './site-admin.component.html',
  styleUrl: './site-admin.component.scss'
})
export class SiteAdminComponent {
  private _storageService: StorageService = inject(StorageService);

  public selectedTab: number;

  constructor() {
    this.selectedTab = 0;

    // Set the initial tab based on any stored value
    const data = this._storageService.loadData(KEY_SITEADMIN_CURRENT_TAB);
    if (data) this.selectedTab = +data;
  }

  /**
   * Track and record updates in the currently selected tab
   *
   * @param tabChangeEvent  tab change event
   */
  public tabChange(tabChangeEvent: MatTabChangeEvent): void {
    this.selectedTab = tabChangeEvent.index;
    this._storageService.saveData(KEY_SITEADMIN_CURRENT_TAB, this.selectedTab.toString());
  }
}
